import { render, staticRenderFns } from "./StopSalariumReminderModal.vue?vue&type=template&id=36e2caf9&"
import script from "./StopSalariumReminderModal.vue?vue&type=script&lang=js&"
export * from "./StopSalariumReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./StopSalariumReminderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports